class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header");
    this.headerIsAlwaysSticky =
      this.getAttribute("data-sticky-type") === "always" ||
      this.getAttribute("data-sticky-type") === "reduce-logo-size";
    this.headerBounds = {};

    this.setHeaderHeight();

    window
      .matchMedia("(max-width: 990px)")
      .addEventListener("change", this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.header.offsetHeight}px`
    );
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky"
    );
    //this.header.querySelector("header.header").classList.remove('header--top-center');
    this.header
      .querySelector("header.header")
      .classList.add("header--middle-left");
    const modalContainer = document.querySelector(
      "#md-app-embed__modal .md-modal__container"
    );
    if (modalContainer) {
      modalContainer.classList.add("modal--middle-left");
    }
    // this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
    //this.header.querySelector("header.header").classList.remove('header--top-center');
    this.header
      .querySelector("header.header")
      .classList.add("header--middle-left");
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate"
    );
    //this.header.querySelector("header.header").classList.add('header--top-center');
    this.header
      .querySelector("header.header")
      .classList.remove("header--middle-left");
    const modalContainer = document.querySelector(
      "#md-app-embed__modal .md-modal__container"
    );
    if (modalContainer) {
      modalContainer.classList.remove("modal--middle-left");
    }
  }

  // closeMenuDisclosure() {
  //   this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  //   this.disclosures.forEach(disclosure => disclosure.close());
  // }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector("details-modal");
    this.searchModal.close(false);
  }
}

customElements.define("sticky-header", StickyHeader);

document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll("li");
  menuItems.forEach((menuItem) => {
    const linkItem = menuItem.querySelector("a.header__menu-item");
    const submenu = menuItem.querySelector(".header__submenu--container");
    const submenuLinks = submenu ? submenu.querySelectorAll("a") : [];
    let hideTimeout;

    function showSubmenu() {
      clearTimeout(hideTimeout);
      if (linkItem) {
        linkItem.classList.add("header__active-menu-item");
      }
    }

    function hideSubmenu() {
      if (linkItem) {
        linkItem.classList.remove("header__active-menu-item");
      }
    }

    if (linkItem) {
      menuItem.addEventListener("mouseenter", showSubmenu);
      menuItem.addEventListener("mouseleave", () => {
        hideTimeout = setTimeout(() => {
          if (!submenu || !submenu.matches(":hover")) {
            hideSubmenu();
          }
        }, 300);
      });
    }

    if (submenu) {
      submenu.addEventListener("mouseenter", () => clearTimeout(hideTimeout));
      submenu.addEventListener("mouseleave", hideSubmenu);
    }

    submenuLinks.forEach((link) => {
      link.addEventListener("mouseenter", () =>
        link.classList.add("header__active-menu-item")
      );
      link.addEventListener("mouseleave", () =>
        link.classList.remove("header__active-menu-item")
      );
    });
  });
});

document.addEventListener("click", function (event) {
  if (event.target.id === "popupOverlay") {
    const closeButton = document.querySelector(".md-modal-closeButton");
    if (closeButton) {
      closeButton.click();
    }
  }

  if (event.target.closest(".md-modal-closeButton")) {
    const icons = document.querySelectorAll(".footer-localization-icon-caret");
    const stickyHeader = document.querySelector("sticky-header");

    icons.forEach((icon) => {
      if (icon && icon.classList.contains("rotate")) {
        icon.classList.remove("rotate");
      }
    });

    document.getElementById("popupOverlay").classList.add("hidden");
    stickyHeader.classList.remove("active");
  }
});
